import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useState } from "react";

export const SettingsDotsIcon: FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      {!is743 ? (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <rect
            width="32"
            height="32"
            rx="4"
            fill="#181A1C"
            fill-opacity="0.45"
          />
          <path
            d="M23.9545 14C25.0842 14 26 14.8954 26 16C26 17.1046 25.0842 18 23.9545 18C22.8247 18 21.9089 17.1046 21.9089 16C21.9089 14.8954 22.8247 14 23.9545 14Z"
            fill={isHovered ? "#FEFEFE" : "#E7E7E7"}
          />
          <path
            d="M16.004 14C17.1337 14 18.0495 14.8954 18.0495 16C18.0495 17.1046 17.1337 18 16.004 18C14.8743 18 13.9584 17.1046 13.9584 16C13.9584 14.8954 14.8743 14 16.004 14Z"
            fill={isHovered ? "#FEFEFE" : "#E7E7E7"}
          />
          <path
            d="M8.04555 14C9.17527 14 10.0911 14.8954 10.0911 16C10.0911 17.1046 9.17527 18 8.04555 18C6.91582 18 6 17.1046 6 16C6 14.8954 6.91582 14 8.04555 14Z"
            fill={isHovered ? "#FEFEFE" : "#E7E7E7"}
          />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="24"
            height="24"
            rx="4"
            fill="#181A1C"
            fill-opacity="0.45"
          />
          <path
            d="M17.5681 11C18.3589 11 19 11.6716 19 12.5C19 13.3284 18.3589 14 17.5681 14C16.7773 14 16.1362 13.3284 16.1362 12.5C16.1362 11.6716 16.7773 11 17.5681 11Z"
            fill="#E7E7E7"
          />
          <path
            d="M12.0028 11C12.7936 11 13.4347 11.6716 13.4347 12.5C13.4347 13.3284 12.7936 14 12.0028 14C11.212 14 10.5709 13.3284 10.5709 12.5C10.5709 11.6716 11.212 11 12.0028 11Z"
            fill="#E7E7E7"
          />
          <path
            d="M6.43188 11C7.22269 11 7.86376 11.6716 7.86376 12.5C7.86376 13.3284 7.22269 14 6.43188 14C5.64108 14 5 13.3284 5 12.5C5 11.6716 5.64108 11 6.43188 11Z"
            fill="#E7E7E7"
          />
        </svg>
      )}
    </>
  );
};
import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useState } from "react";

export const SettingsDotsIcon: FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      {!is743 ? (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <rect
            width="32"
            height="32"
            rx="4"
            fill="#181A1C"
            fill-opacity="0.45"
          />
          <path
            d="M23.9545 14C25.0842 14 26 14.8954 26 16C26 17.1046 25.0842 18 23.9545 18C22.8247 18 21.9089 17.1046 21.9089 16C21.9089 14.8954 22.8247 14 23.9545 14Z"
            fill={isHovered ? "#FEFEFE" : "#E7E7E7"}
          />
          <path
            d="M16.004 14C17.1337 14 18.0495 14.8954 18.0495 16C18.0495 17.1046 17.1337 18 16.004 18C14.8743 18 13.9584 17.1046 13.9584 16C13.9584 14.8954 14.8743 14 16.004 14Z"
            fill={isHovered ? "#FEFEFE" : "#E7E7E7"}
          />
          <path
            d="M8.04555 14C9.17527 14 10.0911 14.8954 10.0911 16C10.0911 17.1046 9.17527 18 8.04555 18C6.91582 18 6 17.1046 6 16C6 14.8954 6.91582 14 8.04555 14Z"
            fill={isHovered ? "#FEFEFE" : "#E7E7E7"}
          />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="24"
            height="24"
            rx="4"
            fill="#181A1C"
            fill-opacity="0.45"
          />
          <path
            d="M17.5681 11C18.3589 11 19 11.6716 19 12.5C19 13.3284 18.3589 14 17.5681 14C16.7773 14 16.1362 13.3284 16.1362 12.5C16.1362 11.6716 16.7773 11 17.5681 11Z"
            fill="#E7E7E7"
          />
          <path
            d="M12.0028 11C12.7936 11 13.4347 11.6716 13.4347 12.5C13.4347 13.3284 12.7936 14 12.0028 14C11.212 14 10.5709 13.3284 10.5709 12.5C10.5709 11.6716 11.212 11 12.0028 11Z"
            fill="#E7E7E7"
          />
          <path
            d="M6.43188 11C7.22269 11 7.86376 11.6716 7.86376 12.5C7.86376 13.3284 7.22269 14 6.43188 14C5.64108 14 5 13.3284 5 12.5C5 11.6716 5.64108 11 6.43188 11Z"
            fill="#E7E7E7"
          />
        </svg>
      )}
    </>
  );
};
